import base from './base';
import { PaletteMode } from '@mui/material';

export default {
  ...base,
  mode: 'dark' as PaletteMode,
  primary: {
    contrastText: '#FFF',
    main: '#6188FF',
    A100: '#6188FF',
    A80: '#9CB0FD',
    A60: '#B8C3FF',
    A40: '#D9DFFF',
    A20: '#E8ECFF',
    A10: '#F5F7FF'
  },
  secondary: {
    contrastText: '#FFF',
    main: '#323546',
    A100: '#323546',
    A80: '#58667E',
    A60: '#636C7F'
  },
  success: {
    contrastText: '#FFF',
    main: '#16C784',
    A100: '#16C784',
    A80: '#2CDB99',
    A60: '#2CDB99',
    A40: '#93EDCB',
    A20: '#B8F2DD'
  },
  warning: {
    contrastText: '#FFF',
    main: '#B05400',
    A100: '#B05400',
    A80: '#CB6000',
    A60: '#FF8F28',
    A40: '#FFAA33',
    A20: '#FFC16A'
  },
  error: {
    contrastText: '#FFF',
    main: '#EA3943',
    A100: '#EA3943',
    A80: '#ED5159',
    A60: '#FF8F95',
    A40: '#FFD1D4',
    A20: '#FFEBEC'
  },
  info: {
    contrastText: '#FFF',
    main: '#717BEB',
    A100: '#717BEB',
    A80: '#848EF5',
    A60: '#9CA4FF',
    A40: '#D9DCFF',
    A20: '#EDEFFF'
  },
  base: {
    main: '#17181B',
    A100: '#17181B',
    A80: '#17171A',
    A60: '#171924',
    A40: '#222531',
    A20: '#272B32',
    A0: '#30353D'
  },
  grayBackground: {
    main: '#646B80',
    A100: '#646B80',
    A80: '#7E899F',
    A60: '#858CA2',
    A40: '#A1A7BB',
    A20: '#A6B0C3',
    A10: '#EFF2F5'
  },
  textColor: {
    main: '#6188FF',
    A80: '#222531',
    A70: '#666666',
    A60: '#58667E',
    A50: '#646B80',
    A40: '#858CA2',
    A30: '#A1A7BB',
    A20: '#A7A8AD',
    A10: '#ADAEB5',
    A0: '#FFFFFF'
  }
};
